import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterByText',
})
export class FilterByTextPipe implements PipeTransform {
  transform(items: any[], searchText: string, field: string): any[] {
    if (!items) return [];
    if (!searchText) return items;
    return items.filter((item) =>
      item[field]?.toLowerCase().includes(searchText.toLowerCase())
    );
  }
}
